import { useQuery } from '@apollo/client';
import type { BulkUpsertRequest } from '@interfaces/bulkUpsertRequest';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_BULK_UPSERT_REQUEST } from './bulkUpsertItemsBreadcrumb.query';

export { FETCH_BULK_UPSERT_REQUEST } from './bulkUpsertItemsBreadcrumb.query';

export const BulkUpsertItemsBreadcrumb = () => {
  const { data } = useQuery(FETCH_BULK_UPSERT_REQUEST, {
    variables: { bulkUpsertRequestId: useParams().bulkUpsertRequestId },
  });
  const { t } = useTranslation();
  const { localizedDateTime } = useLocalization();
  const bulkUpsertRequest: BulkUpsertRequest =
    data?.fetchBulkUpsertRequest?.bulkUpsertRequest;

  return data
    ? `${t(`devSettings:integrationsModal.scopeOptions.DATA_INGESTION.${bulkUpsertRequest.objectType}`)} - ${localizedDateTime(bulkUpsertRequest.createdAt)}`
    : '';
};
